import {BaseDomainModel} from "../base-domain-model";
import {EntityApiModel} from "./entity.api-model";

export class EntityDomainModel extends BaseDomainModel {
  apiModel: EntityApiModel;

  get name(): String {
    return this.apiModel ? this.apiModel.name : '';
  }

  get imageVersion(): String {
    return this.apiModel ? this.apiModel.imageVersion : null;
  }

  get shortName(): String {
    return this.apiModel ? this.apiModel.shortName : '';
  }

  get longName(): String {
    return this.apiModel ? this.apiModel.longName : '';
  }

  get nameForURL(): String {
    return this.apiModel ? this.apiModel.nameForURL : '';
  }

  get popularityRank(): Number {
    return this.apiModel ? this.apiModel.popularityRank : null;
  }

  get createdAt(): Number {
    return this.apiModel ? this.apiModel.createdAt : null;
  }

  get isFollow(): Boolean {
    if (!this.createdAt || typeof this.createdAt !== 'string') {
      return true;
    }

    try {
      const createdAtDate: Date = new Date(this.createdAt);
      const nowUtc: Number = Date.now();
      const diffInMs: Number = nowUtc - createdAtDate.getTime();
      const diffInHours: Number = diffInMs / (1000 * 60 * 60);

      return diffInHours > 24;
    } catch (e) {
      return true;
    }
  }

  get objectType() {
    return this.constructor.name;
  }

  equals(model: EntityDomainModel) {
    let equals = super.equals(model);
    const isSameName = this.name === model.name;

    return equals && isSameName;
  }
}
